"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msalPlugin = void 0;
var msal_1 = require("@elite/msal");
exports.msalPlugin = {
    /**
     * Install the plugin
     * @param app the Vue application
     * @param {MsalService} options the MSAL service
     */
    install: function (app) {
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        var service = (Array.isArray(options) && options[0] ? options[0] : options);
        if (!service ||
            !service.state ||
            !service.state.policyConfig ||
            !service.state.clientApp) {
            throw new Error("Invalid MsalService");
        }
        (0, msal_1.useMsal)(service);
    }
};
//# sourceMappingURL=msalPlugin.js.map